/**
 * Медиавыражения для определения соответствия документа определенному разрешению
 *
 * @name data.EMediaWidth
 * @type {enum}
 */
export enum EMediaWidth {
    desktop = '(min-width: 1600px)',
    sDesktop = '(max-width: 1599px) and (min-width: 1000px)',
    laptop = '(max-width: 999px) and (min-width: 768px)',
    mobile = '(max-width: 767px)',
}

/**
 * Ширина карточки
 *
 * @name data.widthCard
 */
export const widthCard = 345;

/**
 * Максимальное кол-во слайдов для каждого разрешения
 *
 * @name data.dataMaxCountSlides
 * @type {Record<string, number>}
 */
export const dataMaxCountSlides: Record<string, number> = {
    desktop: 4,
    sDesktop: 3,
    laptop: 2,
    mobile: 1,
};
